<template>
  <div class="flex flex-row flex-wrap bg-white px-8 py-4 rounded-xl w-full items-end justify-between gap-2"
       :class="{'border-red-600 border-2': model.error}">

    <div class="flex flex-row flex-wrap gap-2 md:gap-4 items-end">
      <InputField :placeholder="t('inputProductName')" :label="t('productName')" showLabel
            v-model="localModel.nom" required @onChange="resetError" />

      <DropDownField :placeholder="t('selectAColor')" :label="t('color')" required v-model="localModel.couleur"
             :values="couleurStore.couleurs.map(c => ({id: c.uuid, display: c.libelle}))" showLabel @change="resetError" defaultIsNull />

      <div class="flex flex-row gap-4">
        <InputField :placeholder='t("inputQuantity")' :label="t('quantity')" required v-model="localModel.quantite"
                showLabel type="number" :min="1" @onChange="resetError" class="w-1/2 md:!w-16"/>

        <DropDownField placeholder="" :label="t('filling')" required v-model="localModel.remplissage"
               :values="utils.getFillingValues()" showLabel @change="resetError" />
      </div>

      <DropDownField :placeholder="t('filamentType')" required v-model="localModel.typeFilament"
                     :values="typeFilamentStore.typeFilaments.map(c => ({id: c.uuid, display: c.libelle}))" showLabel @change="resetError" defaultIsNull />

      <PurpleFileInputField v-model="localModel.fichier" :defaultValue="localModel.fichier.name" @change="resetError" class="w-full md:w-auto"/>

      <BlueButton :text="t('show3D')" @click="show3DObject" class="w-full md:w-auto"
                  v-show="localModel.fichier.content !== '' || (localModel.fromDraft && localModel.fichier.name !== '' || localModel.hasStl)"/>
    </div>

    <RedButton data-testid="suppressionProduit" :text="t('deleteAProduct')" @click="emit('removeProduit', localModel.uuid);" class="w-full md:w-auto"/>
  </div>
</template>

<script setup>

import {defineEmits, defineProps, ref, watch} from "vue";
import {t} from "@/utils/Traduction";
import InputField from "@/components/molecules/InputField.vue";
import DropDownField from "@/components/molecules/DropDownField.vue";
import PurpleFileInputField from "@/components/molecules/PurpleFileInputField.vue";
import BlueButton from "@/components/molecules/BlueButton.vue";
import RedButton from "@/components/molecules/RedButton.vue";
import {utils} from "@/utils/other";
import xhr from "@/utils/xhr";
import {NotificationStores} from "@/stores/NotificationStores";
import {CouleurStore} from "@/stores/CouleurStore";
import {TypeFilamentStore} from "@/stores/TypeFilamentStore";

const notificationStore = NotificationStores();
const couleurStore = CouleurStore();
const typeFilamentStore = TypeFilamentStore();

const emit = defineEmits(["removeProduit", "show3DRenderModal"]);
const props = defineProps({
  model: {
    type: Object,
    required: true
  }
});

const localModel = ref(props.model);

if(localModel.value.fromDraft && localModel.value.nom === "" && localModel.value.hasStl) {
  localModel.value.fichier.name = "Sans nom";
}

watch(() => typeFilamentStore.typeFilaments, () => {
  localModel.value.typeFilament = localModel.value.typeFilament || typeFilamentStore.typeFilaments.find(c => c.estDefaut)?.uuid;
})

watch(() => localModel.value.fichier, () => {
  localModel.value.fromDraft = false;
})

watch(() => props.model, (newVal) => {
  localModel.value = newVal;

  if(newVal.fromDraft && localModel.value.nom === "") {
    localModel.value.fichier.name = "Sans nom";
  }
});

const resetError = () => {
  localModel.value.error = false;
}

const show3DObject = () => {
  if(localModel.value.fromDraft) {
    xhr.addRequestToQueue("GET", "/brouillons/stl/" + localModel.value.uuid, undefined, true, true, false,
        (response) => {
          if (response.code !== 200) {
            if (response.code === 0 || !JSON.parse(response.response)) {
              notificationStore.addNotification(
                  t("errorDuringGetStl"),
                  "error");
            } else {
              notificationStore.addNotification(
                  JSON.parse(response.response).message,
                  "error");
            }
          } else {
            const stl = JSON.parse(response.response).message

            localModel.value.fichier.content = stl;
            localModel.value.fromDraft = false;
            emit('show3DRenderModal', stl);
          }
        });
  } else {
    emit('show3DRenderModal', localModel.value.fichier.content)
  }
}
</script>

<style scoped>

</style>